<template>
    <div class="relative w-[calc(100%+20px)] h-fit">
        <div class="w-[calc(100%)] h-fit clip-path overflow-hidden">
            <div
                class="carousel-inner flex flex-nowrap h-full"
                :style="{ transform: `translateX(-${currentIndex * 33.333}%)` }"
                :class="{ transition: isTransition }"
                @transitionstart="handleTransition"
            >
                <div class="w-[calc(33.333%-20px)] flex-shrink-0 mr-20px flex relative" v-for="(wrapperItem, index) in itemsShow" :key="index">
                    <div class="flex flex-col w-full h-full">
                        <!-- <img
                            v-for="(item, i) in wrapperItem."
                            :key="i"
                            :src="item"
                            class="w-full h-auto object-cover rounded-8PX"
                            :class="{ 'mb-20px': i !== wrapperItem?.length - 1, 'h-100%!': wrapperItem.length === 1 }"
                        /> -->
                        <ImageVideoLoading
                            type="video"
                            :src="item"
                            v-for="(item, i) in wrapperItem"
                            :key="i"
                            class="w-full h-320 object-cover rounded-8 overflow-hidden"
                            :class="{ 'mb-20': i !== wrapperItem?.length - 1, 'h-100%!': wrapperItem.length === 1 }"
                        ></ImageVideoLoading>
                    </div>
                </div>
            </div>
        </div>
        <template v-if="isCarousel">
            <div
                :key="iconLeftSvg"
                class="absolute right-[-34PX] top-50% mt-[-32PX]"
                @mouseenter="iconLeftSvg = 'svg-icon:prev2'"
                @mouseleave="iconLeftSvg = 'svg-icon:prev1'"
            >
                <Icon :size="40" :icon="iconLeftSvg" @click="next(1)" />
            </div>
            <div
                :key="iconRightSvg"
                class="absolute left-[-64PX] rotate-y-180 top-50% mt-[-32PX]"
                @mouseenter="iconRightSvg = 'svg-icon:prev2'"
                @mouseleave="iconRightSvg = 'svg-icon:prev1'"
            >
                <Icon :size="40" :icon="iconRightSvg" @click="prev(1)" />
            </div>
        </template>
    </div>
</template>

<script setup lang="ts">
import Icon from './Icon/src/Icon.vue';
let iconLeftSvg = 'svg-icon:prev1';
let iconRightSvg = 'svg-icon:prev1';
const animationStart = ref(false);
withDefaults(defineProps<{ items: string[]; pageLen?: number; duration?: number }>(), { items: [],pageLen: 2,duration: 5, })
const currentIndex = ref(0);
const isCarousel = computed(() => __props.items.length > 3);
let timer1: NodeJS.Timeout | undefined;
const handleTransition = () => {
    animationStart.value = true;
    if (timer1) {
        clearTimeout(timer1);
        timer1 = undefined;
    }
    timer1 = setTimeout(() => {
        animationStart.value = false;
    }, 1000);
};
watchEffect(() => {
    if (isCarousel.value) {
        currentIndex.value = __props.items.length;
    } else {
        currentIndex.value = 0;
    }
});
const isTransition = ref(true);
const itemsShow = computed(() => {
    if (isCarousel.value) {
        return [...__props.items, ...__props.items, ...__props.items];
    } else {
        return __props.items;
    }
});
let timer: NodeJS.Timeout | undefined;

const next = (len = 1) => {
    if (timer) {
        clearTimeout(timer);
        timer = undefined;
    }
    isTransition.value = true;
    currentIndex.value = currentIndex.value + len;
    // 最后一屏图片实现无缝衔接
    if (currentIndex.value + __props.pageLen > __props.items.length * 3 - __props.pageLen) {
        setTimeout(() => {
            isTransition.value = false;
            currentIndex.value = currentIndex.value - __props.items.length; // 视觉上回到第一张
        }, 1000); // 等待过渡完成
    } else {
        isTransition.value = true;
    }
};
const prev = (len = 1) => {
    if (timer) {
        clearTimeout(timer);
        timer = undefined;
    }
    isTransition.value = true;
    const cur = currentIndex.value;
    currentIndex.value = cur - len < 0 ? cur - len + __props.items.length : cur - len;
    // 第一屏图片实现无缝衔接
    if (currentIndex.value - __props.pageLen < 0) {
        setTimeout(() => {
            isTransition.value = false;
            currentIndex.value = currentIndex.value + __props.items.length; // 视觉上回到第一张
        }, 1000); // 等待过渡完成
    } else {
        isTransition.value = true;
    }
};
const autoPlay = () => {
    next(1);
    if (__props.items.length > 3) {
        timer = setTimeout(() => autoPlay(), __props.duration * 1000);
    }
};

onMounted(() => {
    // autoPlay();
});
onUnmounted(() => {
    clearTimeout(timer);
});
</script>

<style scoped>
.clip-path {
    clip-path: inset(0 22px 0 0); /* 默认裁剪区域，完全显示 */
}
.carousel-inner {
    &.transition {
        transition: transform 1s ease-in-out;
    }
}
.info {
    opacity: 1;
    &.fade-animation {
        animation: fade 1s ease-in-out; /* 3秒循环往复的动画 */
    }
}

@keyframes fade {
    0% {
        opacity: 0.1;
    }

    100% {
        opacity: 1; /* 结束时不透明 */
    }
}
</style>
